import React from 'react';
import FieldFormula from "../formula";
import {FieldViewSmallProps} from "../../../render/view-small";

// type FieldFormulaViewSmallProps = {
//     field       : FieldFormula
//     model       : any
//     className?  : string
//     onClick?    : onClick
// };

type FieldFormulaViewSmallProps = FieldViewSmallProps & {
    field           : FieldFormula
    options?        : {
        skipCalculation?: boolean       // if true we will use model value (!) and skip calculation
    }
}

export default function FieldFormula_ViewSmall(props:FieldFormulaViewSmallProps) {

    let value : any

    if (!props.options?.skipCalculation) {
        // console.log("calculateValue")
        // default
        value = props.field.calculateValue(props.model)
    } else {
        // console.log("get value from model")
        value = _.get(props.model, props.field.fieldId, null)
    }

    const classes = Classes("ui5-txt-less-important-small", "txt-truncate", props.className, {
        'invalid-value': !props.field.isValueValid(value)
    })

    return (
        <div className={classes}>
            {!_.isNil(value) && _.get(props.field.components, 'ValuePrefix', false)}
            {props.field.getDisplayValue(value)}
        </div>
    );
}
